(() => {
  let request;
  const formatDetails = section => {
    const details = section.querySelector('[data-product-details]');
    if (!details) return;
    details.querySelectorAll('p').forEach(paragraph => {
      const spans = paragraph.querySelectorAll(':scope > span');
      if (spans[0]?.textContent.trim() !== 'size_info' || !spans[1]) return;
      try {
        const rows = JSON.parse(spans[1].textContent).sizeInfoList;
        if (!Array.isArray(rows) || !rows.length) return;
        const countries = [...new Set(rows.flatMap(row => Object.keys(row.countrySizeMap || {})))];
        const table = document.createElement('table'); table.className = 'product-size-table';
        const caption = table.createCaption(); caption.textContent = details.dataset.chartLabel;
        const head = table.createTHead().insertRow();
        [details.dataset.sizeLabel, ...countries, details.dataset.lengthLabel].forEach(label => { const th = document.createElement('th'); th.scope = 'col'; th.textContent = label; head.append(th); });
        const body = table.createTBody();
        rows.forEach(row => { const tr = body.insertRow(); [row.size, ...countries.map(country => row.countrySizeMap?.[country]), row.length?.cm].forEach(value => { tr.insertCell().textContent = value ?? '—'; }); });
        paragraph.replaceWith(table);
      } catch {}
    });
  };
  document.querySelectorAll('[data-product-section]').forEach(formatDetails);
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-gallery-image]');
    if (thumb) { const image = thumb.closest('[data-product-section]').querySelector('#ProductMainImage'); if (image) { image.removeAttribute('srcset'); image.src = thumb.dataset.galleryImage; image.alt = thumb.dataset.galleryAlt; thumb.closest('.gallery-thumbs').querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button === thumb))); } }
    const menu = document.querySelector('.mobile-menu');
    if (menu?.open && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { const menu = document.querySelector('.mobile-menu'); if (menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } } });
  document.addEventListener('change', async event => {
    if (!event.target.matches('[data-option-select]')) return;
    const section = event.target.closest('[data-product-section]');
    const focusId = event.target.id;
    const quantity = section.querySelector('[name="quantity"]').value;
    const status = section.querySelector('[data-variant-status]');
    section.querySelector('.add-to-bag').disabled = true;
    status.textContent = status.dataset.loading;
    request?.abort(); request = new AbortController();
    const url = new URL(section.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', Array.from(section.querySelectorAll('[data-option-select]'), select => select.value).join(','));
    url.searchParams.set('section_id', section.dataset.productSection);
    try {
      const response = await fetch(url, {signal: request.signal});
      if (!response.ok) throw new Error('Variant render failed');
      const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-product-section]');
      if (!next) throw new Error('Missing product section');
      section.replaceWith(next);
      formatDetails(next);
      const qty = next.querySelector('[name="quantity"]'); const n = Number(quantity);
      if (n >= Number(qty.min) && (!qty.max || n <= Number(qty.max)) && (n - Number(qty.min)) % Number(qty.step) === 0) qty.value = quantity;
      const selected = next.querySelector('[name="id"]').value;
      const pageUrl = new URL(location.href); pageUrl.searchParams.delete('option_values');
      if (selected) pageUrl.searchParams.set('variant', selected);
      else { pageUrl.searchParams.delete('variant'); pageUrl.searchParams.set('option_values', url.searchParams.get('option_values')); }
      history.replaceState({}, '', pageUrl);
      document.getElementById(focusId)?.focus({preventScroll: true});
    } catch (error) { if (error.name !== 'AbortError') status.textContent = status.dataset.error; }
  });
})();
(() => {
  document.addEventListener('toggle', event => {
    if (!event.target.matches('.nav-dropdown') || !event.target.open) return;
    const nav=event.target.closest('nav');
    nav?.querySelectorAll('.nav-dropdown').forEach(other=>{if(other!==event.target)other.open=false;});
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open], .filter-dropdown[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;});
  });
  document.addEventListener('keydown', event => {
    if(event.key!=='Escape')return;
    const opened=document.querySelectorAll('.nav-dropdown[open], .filter-dropdown[open]');
    const focused=[...opened].find(details=>details.contains(document.activeElement));
    opened.forEach(details=>details.open=false);
    focused?.querySelector('summary').focus();
  });
})();
